export default __webpack_public_path__ + "static/socsite02-917c987255d7af8316d38421382e3848.png";